import { properties } from '../framework';
import changeDetect from './change-detection';

export default {
  install(Vue) {
    properties(Vue, {
      $changeDetect: changeDetect,
    });
  },
};



// WEBPACK FOOTER //
// ./src/services/index.js